import React, {useState} from "react";
import BizLocationSelector from "../component/BizLocation/BizLocationSelector"
import ProductTypeSelector from "../productType/component/ProductTypeSelector";
import Notify from "../services/Notify";
import StockLevelService from "./StockLevelService";
import {Button, Col, Row} from "react-bootstrap";
import StateStorage from "../utils/StateStorage";
import BizLocationService from "../bizLocation/BizLocationService";
import ModalMessageNew from "../component/Modal/ModalMessageNew";

const BIZ_LOCATION_FILTER_KEY = 'STOCK_LEVEL_FILTER_BIZ_LOCATION';
const PRODUCT_TYPE_FILTER_KEY = 'STOCK_LEVEL_FILTER_PRODUCT_TYPE';

class GridStockLevels {

  customFilters = {
    bizLocation: StateStorage.get(BIZ_LOCATION_FILTER_KEY),
    productType: StateStorage.get(PRODUCT_TYPE_FILTER_KEY),
  };

  title = 'Lista de níveis de estoque';

  exportNewPage = true;

  showPdfButton = false;

  columns = [
    {
      Header: "Referência",
      accessor: "productType.reference"
    },
    {
      Header: "Name",
      accessor: "productType.friendlyName",
      HeaderColumn: true,
    },
    {
      Header: "Local",
      accessor: "bizLocation.friendlyName"
    },
    {
      Header: "Min",
      accessor: "quantityMin"
    },
    {
      Header: "Segurança",
      accessor: "quantitySecure"
    },
    {
      Header: "Max",
      accessor: "quantityMax"
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,

      Cell: row => {
        const [showModal, setShowModal] = useState(false);
        const handleShowModal = () => setShowModal(!showModal);

        const onRowDeleted = async (stockLevelId) => {
          try {
            Notify.showLoading('Deletando...');
            await new StockLevelService().deleteStockLevelById(stockLevelId);
            Notify.success('Nível de estoque deletado com sucesso!');
            this.forceReload && this.forceReload();
          } catch (error) {
            Notify.error(`Erro inesperado:`, error);
          } finally {
            setShowModal(false);
          }
        };

        return (
          <Row className="justify-content-around">
            <Col sm={6}>
              <Button title="Editar" bsStyle="success" href={`#/stock-levels/${row.original && row.original.id}/edit`} block>
                Editar
              </Button>
            </Col>
            <Col sm={6}>
              <Button onClick={handleShowModal} title="Excluir" bsStyle="danger" block>
                Excluir
              </Button>
            </Col>
            <ModalMessageNew
              title={`Deseja excluir o nível de estoque do produto ${row.original.productType.friendlyName}?`}
              showModal={showModal}
              handleShowModal={handleShowModal}
              errorButtonAction={handleShowModal}
              successButtonAction={() => onRowDeleted(row.original.id)}
            />
          </Row>
        );
      }
    }

  ];

  endpoint = (props, state) => {
    const params = new URLSearchParams({});
    this.customFilters.bizLocation && params.append('_bizLocationId', this.customFilters.bizLocation.id);
    this.customFilters.productType && params.append('_productTypeId', this.customFilters.productType.id);
    return `ton/v1/stock-levels?${params.toString()}`;
  };

  setBizLocationIdInUrl = (bizLocationId) => {
    const urlPattern = /stock-levels$/gm

    if (urlPattern.test(window.location.href)) {
      window.location.replace(window.location.href.replace(/$/, `/${bizLocationId}`))
    }
  }

  customFilterComponent = (props, state, onChange) => {

    const setBizLocation = (bizLocation) => {
      StateStorage.set(BIZ_LOCATION_FILTER_KEY, bizLocation);
      bizLocation && this.setBizLocationIdInUrl(bizLocation.id);
      this.customFilters.bizLocation = bizLocation;
      onChange(bizLocation);
    }

    return (
      <Row>
        <Col lg={6}>
          <BizLocationSelector
            defaultValueFunction={async (selector) => {
              const {bizLocationId} = props.match.params
              const storagedBizLocationId = this.customFilters.bizLocation && this.customFilters.bizLocation.id

              if (bizLocationId && bizLocationId !== storagedBizLocationId) {
                const bizLocation = await new BizLocationService().findById(props.match.params.bizLocationId)
                setBizLocation(bizLocation)
                selector.setState({defaultValue: bizLocation, value: bizLocation})
              }

              setBizLocation(this.customFilters.bizLocation)
              selector.setState({defaultValue: this.customFilters.bizLocation, value: this.customFilters.bizLocation})
            }}
            onChange={setBizLocation}/>
        </Col>
        <Col lg={6}>
          <ProductTypeSelector
            defaultValue={this.customFilters.productType}
            onChange={value => {
              StateStorage.set(PRODUCT_TYPE_FILTER_KEY, value);
              this.customFilters.productType = value;
              onChange(value);
            }}/>
        </Col>
      </Row>
    )
  }
}

export default GridStockLevels;



// WEBPACK FOOTER //
// ./src/stockLevel/StockLevelGrid.js